module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAADeCAYAAAAeoXEKAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABASURBVHgB7c2hEQAhEARB/hMiBeIgGoLGH4VBgT3VU7WqxX41ZpRLf3kEAAAgF06tj9jLPAcAAAAAAAAAAEAaLJHeCQ0m1FcDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigscreenSales/statistics_line.png
// module id = x6d6
// module chunks = 1